"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _imageCandidateMotionStylex = require("web/shared/imageCandidates/imageCandidateMotion.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Styles for the candidate strip: one frame at the height it is given,
 * the candidates scrolling sideways inside it, the chosen one outlined in
 * the accent, and the add button as an end cap off the scroll.
 */ // Set on the frame by whoever renders the strip. The inner heights are
// written out rather than as percentages, which a flex item's picture
// does not reliably resolve against.
const STRIP_HEIGHT = "var(--strip-height)"; // Also the space between candidates, so one stands as far from its
// neighbor as from the frame.
const STRIP_PADDING = "1rem";
const STRIP_BORDER = "1px";
const CANDIDATE_BORDER = "4px";
const CANDIDATE_HEIGHT = "calc(".concat(STRIP_HEIGHT, " - 2 * ").concat(STRIP_PADDING, " - 2 * ").concat(STRIP_BORDER, ")");
const PICTURE_HEIGHT = "calc(".concat(CANDIDATE_HEIGHT, " - 2 * ").concat(CANDIDATE_BORDER, ")"); // The accent thinned to a glow, for the ring a newly chosen picture casts,
// and to a tint, for the ground of a pointed-at control.
const ACCENT_GLOW = "color-mix(in srgb, ".concat(_tokensStylex.tokens.accent, " 55%, transparent)");
const ACCENT_TINT = "color-mix(in srgb, ".concat(_tokensStylex.tokens.accent, " 10%, transparent)");
const ACCENT_GONE = "transparent"; // A picture just chosen: a ring of the accent swells out from its
// border and fades. The picture itself holds still.
const chosenRing = "x2mdzgm-B";
const styles = exports.styles = {
  frame: {
    position: "x1n2onr6",
    display: "x78zum5",
    alignItems: "x1qjc9v5",
    height: "x6r1kys",
    maxHeight: "xum3wxm",
    width: "xh8yej3",
    minWidth: "xeuugli",
    boxSizing: "x9f619",
    margin: "x18gkxj7",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x9mmeec",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    backgroundColor: "x1r51w2g",
    transition: "x1w89ptl x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  frameDropping: {
    borderStyle: "xbsl7fq",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "xs5ia2r",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "x1uiyw2v",
    $$css: true
  },
  dropNote: {
    position: "x10l6tqk",
    top: "x13vifvy",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    zIndex: "xhtitgo",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "x1uma3xh",
    rowGap: null,
    columnGap: null,
    fontFamily: "x1wl88yq",
    fontSize: "xyr29y3",
    fontWeight: "x1s688f",
    color: "x19p3n1p",
    backgroundColor: "x1wparz",
    opacity: "xg01cxk",
    pointerEvents: "x47corl",
    transition: "xq4ffd0 x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  dropNoteShown: {
    opacity: "x1hc1fzr",
    $$css: true
  },
  dropNoteRing: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    width: "xb1qrhf",
    height: "x12hms15",
    boxSizing: "x9f619",
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "xdh2fpr",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "xbsl7fq",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1r7ld26",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  strip: {
    listStyle: "xe8uvvx",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    display: "x78zum5",
    flexWrap: "xozqiw3",
    alignItems: "x6s0dn4",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    flexGrow: "x1iyjqo2",
    flexShrink: "xs83m0k",
    minWidth: "xeuugli",
    height: "x5yr21d",
    boxSizing: "x9f619",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    overflowX: "x14aock7",
    overflowY: "x10wlt62",
    scrollbarWidth: "x1597r2g",
    scrollbarColor: "x1nhoopy",
    $$css: true
  },
  stripEmpty: {
    justifyContent: "xl56j7k",
    $$css: true
  },
  backToStart: {
    position: "x10l6tqk",
    left: "x1pemb1n",
    insetInlineStart: null,
    insetInlineEnd: null,
    top: "xwa60dl",
    transform: "x1jahu2u",
    opacity: "xg01cxk",
    pointerEvents: "x47corl",
    transition: "x8cffjd x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  backToStartShown: {
    transform: "x1cdci3v",
    opacity: "x1hc1fzr",
    pointerEvents: "x67bb7w",
    $$css: true
  },
  candidate: {
    position: "x1n2onr6",
    flexShrink: "x2lah0s",
    height: "x7yjori",
    boxSizing: "x9f619",
    borderWidth: "x1a87jhh",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x36g49h",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x9mmeec",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    backgroundColor: "x1r51w2g",
    transition: "x13i6cvv x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  candidateChosen: {
    borderColor: "xs5ia2r",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  candidateChoosing: {
    borderColor: "xs5ia2r",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    animationName: "xzqxhuz",
    animationDuration: "xof6966 x1u6grsq",
    animationTimingFunction: "x1e7x7q8",
    animationFillMode: "x1u6ievf",
    $$css: true
  },
  picture: {
    display: "x1lliihq",
    height: "xntybbm",
    width: "x14atkfc",
    maxWidth: "x1x1rfll",
    $$css: true
  },
  candidateActions: {
    position: "x10l6tqk",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    padding: "xq068xy",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    opacity: "xg01cxk",
    transform: "x1djf54w",
    pointerEvents: "x47corl",
    transition: "xz5f0ic x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  candidateActionsShown: {
    opacity: "x1hc1fzr",
    transform: "xnn1q72",
    pointerEvents: "x67bb7w",
    $$css: true
  },
  addSlot: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    flexShrink: "x2lah0s",
    alignSelf: "xkh2ocl",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "xa7bee3",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: "xe0pwq",
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderLeftStyle: "x19ypqd9",
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderLeftColor: "xoplvca",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    backgroundColor: "xjbqb8w xwbqp3j x1d5rubi x1oqui1x",
    color: "x10kmngs x1qfsr1m xkguk39 x100nr68",
    cursor: "x1ypdohk xtgyt42",
    transition: "x47glr1 x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  addRing: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    width: "x1s4ejo4",
    height: "xk8t5le",
    boxSizing: "x9f619",
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    borderWidth: "xdh2fpr",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1r7ld26",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "xk6p4me",
    color: "x1heor9g",
    $$css: true
  },
  stripNote: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1nrrp6k",
    color: "xcdm7ny",
    $$css: true
  },
  error: {
    margin: "xq305sd",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1qzg9v8",
    lineHeight: "x1evy7pa",
    color: "xwiuzjs",
    $$css: true
  },
  tip: {
    display: "x1lliihq",
    padding: "xvbp85x",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "x18jy0o0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontSize: "xboafo0",
    fontWeight: "xk50ysn",
    lineHeight: "xwn7fz2",
    whiteSpace: "xuxw1ft",
    color: "x12y22ox",
    backgroundColor: "x13nbq8d",
    boxShadow: "x1478hrd",
    $$css: true
  }
};